import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDrawer,
    {
      attrs: {
        "data-qa": "laboratories-list-modal",
        title: _setup.isShowEmptyState ? "" : "Выберите лабораторию",
      },
      on: { input: _setup.handleInput },
      scopedSlots: _vm._u(
        [
          !_setup.isShowEmptyState
            ? {
                key: "header",
                fn: function () {
                  return [_c(_setup.LaboratoriesListSearch)]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
      model: {
        value: _setup.isActiveDrawer,
        callback: function ($$v) {
          _setup.isActiveDrawer = $$v
        },
        expression: "isActiveDrawer",
      },
    },
    [
      _vm._v(" "),
      _setup.isShowEmptyState
        ? _c(
            "div",
            {
              staticClass: "d-flex flex-column justify-center fill-height px-4",
              attrs: { "data-qa": "laboratories-empty-state" },
            },
            [
              _c(VImg, {
                staticClass: "mx-auto mb-4",
                attrs: {
                  width: "175",
                  "min-height": "175",
                  "max-height": "175",
                  src: "/static/_v1/pd/pictures/stubs/empty-cart.png",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-h6 text--text mb-2 text-center" },
                [
                  _vm._v(
                    "\n      Нет лабораторий, где можно сдать все анализы из корзины\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-body-1 text-secondary--text text-center" },
                [_vm._v("\n      Попробуйте убрать некоторые анализы\n    ")]
              ),
            ],
            1
          )
        : _setup.isWithoutRequests
        ? _c(_setup.LaboratoriesListSkeletons, { staticClass: "px-2" })
        : _c(_setup.LaboratoriesListLabs, {
            attrs: { "x-space-class": "px-4" },
            on: {
              "click:lab": function ($event) {
                return _setup.emit("click:lab", $event)
              },
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }